import type { FaireProductEntity } from "../../entity_types/product";

export const p_dhrq3ncsq2: FaireProductEntity = {
  token: "p_dhrq3ncsq2",
  type: "product",
  name: "Let Me Sleep - Natural Sleep Supplement",
  brandToken: "b_wqmd5mntt6",
  brandName: "Womaness",
  imageUrl:
    "https://cdn.faire.com/fastly/5e1c3fc94de094ec280def1693c8557d4a4dec668abd4e4577e3643904b88297.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/82725adbf40656268b37b89336bc6dab3b68dd481e0f130ffa9897429f51c181.webp",
    "https://cdn.faire.com/fastly/dca84a7028c6c53d46dba33a39606ff5aae7cd853bc9aa1af3d79fdc76458c0c.webp",
    "https://cdn.faire.com/fastly/84b197a162727cdf7a40412a0621a305640ebcf4309a5ad1dddbad383dd69878.webp",
    "https://cdn.faire.com/fastly/c11559bd33bcefab941b70fc13cdb8e4393b94e6fe79727823209fa2168fdae6.webp",
    "https://cdn.faire.com/fastly/a05192a445898714cb46d67adce746c510c41875ad9c8d8c594139c1d89e27a9.webp",
    "https://cdn.faire.com/fastly/027a4193ee9f176ba40837195e49d60b6422a8174afde1a30e2e1c4f51796c07.webp",
  ],
  priceDollars: 17.54,
  description:
    "Meet our natural, drug-free, non-habit-forming way to fall asleep, stay asleep, feel calm, and wake up rested. (You seriously deserve this.)\n\n- Fall asleep in a relaxed state with naturally good ingredients like magnesium, GABA (for its stress-reducing superpower), and a nighttime classic: chamomile\n- Stay asleep thanks to MicroActive® Melatonin with its longer sustained-release formula\n- Wake up rested, recharged, and unstoppable\n- Certified GMP (Good Manufacturing Practice)\n\nYour least favorite symptom in menopause? Lack of sleep. Because in this phase of life, it’s not just about falling asleep...it’s about staying there. That’s why we chose innovative, clinically proven ingredients—like MicroActive® Melatonin, with its longer sustained-release formula, and highly bioactive, naturally derived magnesium—to help you wake fully rested and feeling back to your unstoppable, up-and-at-‘em self.*\n",
  tags: [],
  msrpDollars: 26.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:48.293Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
